module.exports = __webpack_public_path__ + "img/arrow-hover.ca2d420d.svg";